// import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin(() => {
  //   const router = useRouter()
  //   const {
  //     public: { sentry }
  //   } = useRuntimeConfig()
  //   if (!sentry.dsn || !sentry.environment || sentry.environment === 'development') {
  //     return
  //   }
  //   console.log('Initializing Sentry with DSN', sentry.dsn, 'and environment', sentry.environment)
  //   Sentry.init({
  //     app: nuxtApp.vueApp,
  //     dsn: sentry.dsn,
  //     environment: sentry.environment,
  //     integrations: [
  //       Sentry.browserTracingIntegration({ router }),
  //       Sentry.replayIntegration({
  //         maskAllText: false,
  //         blockAllMedia: false
  //       })
  //     ],
  //     tracesSampleRate: 1.0,
  //     tracePropagationTargets: ['localhost', 'https://ceto.ai'],
  //     replaysSessionSampleRate: 0.1,
  //     replaysOnErrorSampleRate: 1.0
  //   })
})
